export default {
  SET_PURCHASE_ORDERS(state, purchase_orders) {
    state.purchase_orders = purchase_orders
  },
  REMOVE_PURCHASE_ORDERS(state, itemId) {
      const roleIndex = state.purchase_orders.datas.findIndex((u) => u.id == itemId)
      state.purchase_orders.datas.splice(roleIndex, 1)
  },
  SELECTED_PURCHASE_ORDERS(state,data){
    state.purchase_orders.datas = []
    state.purchase_orders.total = 1;
    state.purchase_orders.per_page = 1;
    state.purchase_orders.datas.push(data)
  },
  SET_AUTOCOMPLETE_DATA(state,data){
    state.autocomplete_data = data
  },
  EDIT_ITEM(state,data){
    state.elomark_user = data
  },
  ADD_ITEM(state,data){
    state.elomark_user = data
  },
}
